var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center fill-height justify-center"},[_c('div',[_c('h1',{staticClass:"my-4"},[_vm._v("¡Oops! 401")]),_c('p',[_vm._v("Lo siento, no tienes permisos para acceder a esta página")]),_c('v-btn',{staticClass:"my-1 text-none",attrs:{"to":{
				name: 'Dashboard',
			},"color":"primary","rounded":"","link":""}},[_vm._v(" Ir a la página de Inicio ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }